export const SnapdocsSubscriptionsLoadState = {
  LOADING: 'loading',
  LOADED: 'loaded',
  NOT_CONFIGURED: 'notConfigured',
  UNAVAILABLE: 'unavailable',
  ERROR: 'error',
};
